import type { NonCustomOnboardingTourStepOption } from 'models';

export const useSupportedStepTitle = ({ step }: { step: NonCustomOnboardingTourStepOption }) => {
  switch (step) {
    case 'consents':
      return 'Confirm consents';
    case 'profile':
      return 'Make it yours!';
  }
};
